import { ConfigProvider, theme } from 'antd';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppLayout } from './shell/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './shell/DashboardPage';
import { CorrectionQueuePage } from './pages/CorrectionQueuePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { MRListPage, POListPage, GRNListPage, ReturnsListPage } from './modules/purchasing';

const lasheenTheme = {
  token: {
    colorPrimary: '#000000',
    colorLink: '#000000',
    borderRadius: 6,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  algorithm: theme.defaultAlgorithm,
};

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <ConfigProvider theme={lasheenTheme}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/corrections" element={<CorrectionQueuePage />} />
                      {/* Purchasing module routes */}
                      <Route path="/purchasing/mrs" element={<MRListPage />} />
                      <Route path="/purchasing/pos" element={<POListPage />} />
                      <Route path="/purchasing/grns" element={<GRNListPage />} />
                      <Route path="/purchasing/returns" element={<ReturnsListPage />} />
                      {/* Additional module routes will be added per phase */}
                      <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}
